export const CREATE_PENDING_DOCUMENT = `
mutation createPendingDocument($file: Upload!, $input: CreatePendingDocumentInput!) {
  createPendingDocument(file: $file, input: $input) {
    __typename
    ... on PendingDocumentResponse {
      filename
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;
